// =============================================================================
// API — dashboard
// Llama a GET /dashboard/summary
// -----------------------------------------------------------------------------
// Patrón del proyecto (verificado en patients.ts, budgets.ts, etc.):
//   import { api } from './client';
//   return api.get<T>(url);   // devuelve T directamente, no { data: T }
//
// Lección aplicada: NO enviamos `allSites=false` al backend.
// Con enableImplicitConversion, el string "false" se convierte a true.
// Si allSites es falsy, omitimos el parámetro entero.
// =============================================================================

import { api } from './client';
import type { DashboardQueryParams, DashboardSummary } from '../types/dashboard';
import type { SystemHealth } from '../types/system-health';

export async function getDashboardSummary(
  params: DashboardQueryParams,
): Promise<DashboardSummary> {
  const q: Record<string, string> = {};
  if (params.preset) q.preset = params.preset;
  if (params.from) q.from = params.from;
  if (params.to) q.to = params.to;
  if (params.allSites === true) q.allSites = 'true';
  // allSites=false se omite a propósito (lección enableImplicitConversion)

  const search = new URLSearchParams(q).toString();
  const url = search ? `/dashboard/summary?${search}` : '/dashboard/summary';

  return api.get<DashboardSummary>(url);
}

export async function getSystemHealth(): Promise<SystemHealth> {
  return api.get<SystemHealth>('/dashboard/system-health');
}
